import { render, staticRenderFns } from "./QuizStudentOverview.vue?vue&type=template&id=664a04ef&"
import script from "./QuizStudentOverview.vue?vue&type=script&lang=js&"
export * from "./QuizStudentOverview.vue?vue&type=script&lang=js&"
import style0 from "./QuizStudentOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports